import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ErrorPopUpState {
  show: boolean;
  message: string;
}

interface CommonState {
  errorPopUp: ErrorPopUpState;
}

const initialState: CommonState = {
  errorPopUp: {
    show: false,
    message: '',
  },
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<string>) => {
      state.errorPopUp.show = true;
      state.errorPopUp.message = action.payload;
    },
    clearError: (state) => {
      state.errorPopUp.show = false;
      state.errorPopUp.message = '';
    },
  },
});

export const { setError, clearError } = commonSlice.actions;
export const getErrorPopUpState = (state: any) => state.common.errorPopUp;

export default commonSlice.reducer;
